<template>
    <div class="toTop" style="-webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);" @click="toTop()">
        <img src="../../public/img/toTop.png" width="60px" alt="" srcset="">
    </div>
</template>
<script>
export default {
    methods:{
        toTop(){
            // document.body.scrollTop
            document.getElementById("app").scrollIntoView();
        }
    }
}
</script>
<style lang="less">
.toTop{
    position: fixed;
    bottom: 50px;
    right: 50px;
    z-index: 10000;
    transition: 0.1s all linear;
    border-radius: 50%;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);    
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
    img{
        display: block;
    }
}
.toTop:hover{
    transform: scale(1.1);
}
</style>

